import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { openUserDropdown, closeUserDropdown, openNotificationsDropdown, closeNotificationsDropdown, toggleSubmitMenu, openSearchModal, closeSearchModal, toggleSearchModal, siteHeaderSearchButtonClicked, toggleBurgerMenuRequested, userLogoutButtonClicked, toggleFeedbackPage } from './actions';
import { reduxKey } from './constants';
export const initialState = {
    isSearchModalShown: false,
    isUserDropdownOpen: false,
    isBurgerMenuOpen: false,
    isNotificationsDropdownOpen: false,
    isSubmitMenuOpen: false,
    isLoggingOut: false
};
const actionHandlers = handleActions({
    [openSearchModal.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isSearchModalShown: true,
            isUserDropdownOpen: false,
            isNotificationsDropdownOpen: false
        }),
    [closeSearchModal.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isSearchModalShown: false
        }),
    [toggleSearchModal.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isSearchModalShown: !state.isSearchModalShown
        }),
    [siteHeaderSearchButtonClicked.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isUserDropdownOpen: false,
            isNotificationsDropdownOpen: false
        }),
    [openUserDropdown.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isUserDropdownOpen: true,
            isNotificationsDropdownOpen: false
        }),
    [closeUserDropdown.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isUserDropdownOpen: false
        }),
    [openNotificationsDropdown.toString()]: (state)=>{
        return _object_spread_props(_object_spread({}, state), {
            isNotificationsDropdownOpen: true,
            isUserDropdownOpen: false
        });
    },
    [closeNotificationsDropdown.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isNotificationsDropdownOpen: false
        }),
    [toggleFeedbackPage.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isNotificationsDropdownOpen: false
        }),
    [toggleSubmitMenu.toString()]: (state)=>{
        const isOpen = !state.isSubmitMenuOpen;
        return _object_spread_props(_object_spread({}, state), {
            isSubmitMenuOpen: isOpen
        });
    },
    [toggleBurgerMenuRequested.toString()]: (state, { payload: { isOpenAfter } })=>_object_spread_props(_object_spread({}, state), {
            isBurgerMenuOpen: isOpenAfter !== null && isOpenAfter !== void 0 ? isOpenAfter : !state.isBurgerMenuOpen
        }),
    [userLogoutButtonClicked.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isLoggingOut: true
        })
}, initialState);
export default {
    [reduxKey]: actionHandlers
};
